function getts(){
  let date = new Date()
  let str = date.getTime()
  return str.toString()
}

function correct(n){
  return n>9?n:"0"+n
}

function getDate(time){
  let date = new Date(time * 1000)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let d = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let result = year + "年" + month + "月" + d + "日 " + correct(hour) + ":" + correct(minute)
  return result
}
function formatDotTime(time){
  if(!time) return ''
  let date = new Date(time * 1000)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let d = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()
  let result = year + "." + correct(month) + "." + correct(d) + " " + correct(hour) + ":" + correct(minute) + ":" +correct(second)
  return result
}

function formatTime_full(time){
  if(!time) return ''
  let date = new Date(time * 1000)
  let second = date.getSeconds()
  let result = formatTime_yyyyMMddhhmm(time) + ":" + correct(second)
  return result
}

function formatPrice(value){
  if (isNaN(value)) {
    return "";
  }else if(value%100>0){
    return (value / 100).toFixed(2)
  }
  return (value / 100).toFixed(0);
}

function formatStatus(value, status) {
  for (let i in status) {
    if (value == status[i].key) {
      return status[i].val;
    }
  }
  return '';
}

function formatTime_yyyyMMdd(time){
  let date = new Date(time * 1000)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let d = date.getDate()
  let result = year + "-" + correct(month) + "-" + correct(d)
  return result
}
// 去0函数
function removeLeftZero(str){
  if(!str) return ''
  return parseInt(str)
}
//补0函数
function padLeftZero(str) {
  return ('00'+str).substring(str.length)
}
// 格式化时间首先考虑 formatDate
/**
 * 
 * @param {*} time 时间戳单位s eg 
 * @param {String} fmt 时间格式 eg  'yyyy.MM.dd hh:mm:ss'
 * @returns 
 */
function formatDate (time, fmt) {
  if(!time) return ''
  let date = new Date(time * 1000)
  //返回固定的年份
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substring(4 - RegExp.$1.length))
    };
    //定义时间正则对象
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    //遍历 正则替换
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1 === 1) ? str : padLeftZero(str));
      }
    }
    return fmt;
  }
export default{
  getts: getts,
  getDate: getDate,
  formatPrice,
  formatStatus,
  formatDotTime,
  formatDate,
  removeLeftZero,
  formatTime: formatTime_full,
  formatTime_ymd: formatTime_yyyyMMdd,
}


// WEBPACK FOOTER //
// ./src/utils/index.js